import FormationBuilderPage from "../FormationBuilderPage";

const technicienMaintenanceMultiTechniqueProgram = [
  {
    title: "Habilitation électrique (BR / B1V / BC)",
    img: "/assets/images/icon/light.svg",
  },
  {
    title: "Lecture de schémas électriques bâtiment",
    img: "/assets/images/icon/light.svg",
  },
  {
    title: "GTB / GTC : supervision, alarmes, pilotage",
    img: "/assets/images/icon/component-card.svg",
  },
  {
    title: "Capteurs bâtiment (température, présence, luminosité)",
    img: "/assets/images/icon/rule.svg",
  },
  {
    title: "Mécanique appliquée à la maintenance tertiaire",
    img: "/assets/images/icon/setting.svg",
  },
  {
    title: "Mesures dimensionnelles (pied à coulisse, comparateur)",
    img: "/assets/images/icon/rule.svg",
  },
  {
    title: "CVC : chauffage, ventilation, climatisation",
    img: "/assets/images/icon/ampoul.svg",
  },
  { title: "Diagnostic de pannes CVC", img: "/assets/images/icon/ampoul.svg" },
  {
    title: "Plomberie & réseaux sanitaires (EF / ECS / EU / EV)",
    img: "/assets/images/icon/tuyaux.svg",
  },
  {
    title: "Méthodologie de maintenance : QQOQCP, 5 Pourquoi",
    img: "/assets/images/icon/setting.svg",
  },
  {
    title: "Amélioration continue : TPM, 5S, Kaizen",
    img: "/assets/images/icon/redaction.svg",
  },
  {
    title: "GMAO : traçabilité et procédures de contrôle",
    img: "/assets/images/icon/fiche.svg",
  },
  {
    title: "Outils bureautiques : Word, Excel",
    img: "/assets/images/icon/fiche.svg",
  },
  { title: "Anglais technique", img: "/assets/images/icon/work-women.svg" },
  {
    title: "Posture professionnelle & relation client",
    img: "/assets/images/icon/work-women.svg",
  },
  { title: "Management de projet", img: "/assets/images/icon/work-women.svg" },
  {
    title: "Projets intégrés — maintenance globale bâtiment",
    img: "/assets/images/icon/setting.svg",
  },
  {
    title: "Étude de cas / Projet de fin de parcours",
    img: "/assets/images/icon/fiche.svg",
  },
];

const TechnicienMaintenanceMultiTechnique = () => (
  <FormationBuilderPage
    category="BTP-Tertiaire"
    titleColor="#2424FF"
    title="Technicien de Maintenance Multi-technique"
    duration={11}
    description={
      <p>
        Grâce au partenariat entre Liora et Vinci Facilities, rejoignez l'un des
        leaders français des services multi-techniques et de la performance
        énergétique des bâtiments en tant que Technicien de Maintenance
        Multi-technique, après une formation accélérée de 11 semaines.
        Performance énergétique des bâtiments, maintenance multi-technique,
        smart building, transition environnementale... rythment le quotidien de
        nos équipes, pourquoi pas le vôtre ?
      </p>
    }
    image="/assets/images/home/btp-tertiaire.png"
    formId="579c6f97-2c06-4ec0-ba1f-742922cc6853"
    popupFormId="5705be1e-3baf-4d49-9f13-541b1db0c861"
    program={technicienMaintenanceMultiTechniqueProgram}
  />
);

export default TechnicienMaintenanceMultiTechnique;
